import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import useAxios from "../../services/useAxios";

import { CustomInput, ReactSelect } from "../kits/Inputs/Inputs";
import CustomButton from "../kits/button/CustomButton";

import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

import "./order-filter-style.scss";

export default function OrderFilter({
  show,
  setShow,
  productDebounce,
  customerDebounce,
  productListOption,
  customerListOption,
  changeDataFilter,
  filterData,
  statusList,
  filterFunc,
  setFilterFlag,
  orderListFunc,
}) {
  const orderType = [
    { value: "1", label: "خرید" },
    { value: "2", label: "فروش" },
  ];
  const paidType = [
    { value: "1", label: "پرداخت شده" },
    { value: "2", label: "پرداخت نشده" },
  ];
  console.log("filterData", filterData);
  return (
    <Modal show={show} onHide={setShow} contentClassName="order-filter-style">
      <Modal.Header closeButton>فیلتر سفارش</Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-wrap ">
          <div className="mt-2 px-1 col-4">
            <ReactSelect
              title="نوع سفارش"
              itemsList={orderType}
              inputValue={filterData?.type}
              onChangeFunc={(e) => {
                changeDataFilter({ type: e });
              }}
              inputSize="same-as-select"
              isClearable={true}
            ></ReactSelect>
          </div>
          <div className="mt-2 px-1 col-8">
            <ReactSelect
              title="محصول"
              itemsList={productListOption}
              inputValue={filterData?.product}
              onChangeFunc={(e) => {
                changeDataFilter({
                  product: {
                    ...e,
                    properties: e?.properties?.map((v) => {
                      return { ...v, inputValue: "" };
                    }),
                  },
                });
              }}
              inputSize="same-as-select"
              onInputChangeFunc={(value) => {
                productDebounce(value);
              }}
              isClearable={true}
            ></ReactSelect>
          </div>
          {filterData?.product?.properties?.length > 0 && (
            <div className="w-100 d-flex flex-wrap border rounded shadow py-2 px-1">
              <span className="w-100" style={{ fontSize: 12 }}>
                صفات محصول
              </span>
              {filterData?.product?.properties?.map((value) => {
                if (value?.type == 2) {
                  let option = value?.options?.split(",");
                  option = option.map((v) => {
                    return { value: v, label: v };
                  });
                  console.log("filterData funct", value);

                  return (
                    <div className="mt-2 px-1 col-6">
                      <ReactSelect
                        title={value?.title ?? ""}
                        itemsList={option}
                        inputValue={value?.inputValue}
                        onChangeFunc={(e) => {
                          changeDataFilter(
                            { inputValue: e },
                            "productProperties",
                            value?.product_properties__id
                          );
                        }}
                        inputSize="same-as-select"
                        onInputChangeFunc={(value) => {
                          productDebounce(value);
                        }}
                        isClearable={true}
                      ></ReactSelect>
                    </div>
                  );
                } else if (value?.type == 1) {
                  return (
                    <div className="mt-2 px-1 col-6">
                      <CustomInput
                        label={value?.title}
                        inputValue={value?.inputValue}
                        onChangeFunc={(e) => {
                          if (!isNaN(e.target.value)) {
                            changeDataFilter(
                              { inputValue: e.target.value },
                              "productProperties",
                              value?.product_properties__id
                            );
                          }
                        }}
                      />
                    </div>
                  );
                }
              })}
            </div>
          )}
          {/* <div className="mt-2 px-1 col-12">
            <ReactSelect
              title="کاربران ثبت کننده"
              itemsList={[]}
              inputValue={""}
              onChangeFunc={(e) => {}}
              isMulti={true}
              inputSize="same-as-select"
            ></ReactSelect>
          </div> */}

          <div className="mt-2 px-1 col-6">
            <ReactSelect
              title="مشتری"
              itemsList={customerListOption}
              inputValue={filterData?.customer}
              onChangeFunc={(e) => {
                changeDataFilter({ customer: e });
              }}
              inputSize="same-as-select"
              onInputChange={(value) => {
                customerDebounce(value);
              }}
              isClearable={true}
            ></ReactSelect>
          </div>
          <div className="mt-2 px-1 col-6">
            <ReactSelect
              title="وضعیت پرداخت"
              itemsList={paidType}
              inputValue={filterData?.paid_status}
              onChangeFunc={(e) => {
                changeDataFilter({ paid_status: e });
              }}
              inputSize="same-as-select"
              isClearable={true}
            ></ReactSelect>
          </div>
          <div className="mt-2 px-1 col-6">
            <ReactSelect
              title="وضعیت تولید"
              itemsList={statusList?.production}
              inputValue={filterData?.production_status}
              onChangeFunc={(e) => {
                changeDataFilter({ production_status: e });
              }}
              inputSize="same-as-select"
              isClearable={true}
            ></ReactSelect>
          </div>
          <div className="mt-2 px-1 col-6">
            <ReactSelect
              title="وضعیت انبار"
              itemsList={statusList?.store}
              inputValue={filterData?.store_status}
              onChangeFunc={(e) => {
                changeDataFilter({ store_status: e });
              }}
              inputSize="same-as-select"
              isClearable={true}
            ></ReactSelect>
          </div>
          <div className="mt-2 px-1 col-6">
            <ReactSelect
              title="وضعیت مالی"
              itemsList={statusList?.financial}
              inputValue={filterData?.financial_status}
              onChangeFunc={(e) => {
                changeDataFilter({ financial_status: e });
              }}
              inputSize="same-as-select"
              isClearable={true}
            ></ReactSelect>
          </div>
          <div className="mt-2 px-1 col-6">
            <ReactSelect
              title="وضعیت سفارش"
              itemsList={statusList?.detail_order}
              inputValue={filterData?.order_status}
              onChangeFunc={(e) => {
                changeDataFilter({ order_status: e });
              }}
              inputSize="same-as-select"
              isClearable={true}
            ></ReactSelect>
          </div>
          <div className="col-6 mt-2 px-1">
            <label className="form-label-custom" style={{ marginBottom: 8 }}>
              از تاریخ ثبت
            </label>
            <DatePicker
              value={filterData?.from_tm}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              onChange={(e) => {
                changeDataFilter({ from_tm: e });
              }}
            />
          </div>
          <div className="col-6 mt-2 px-1">
            <label className="form-label-custom" style={{ marginBottom: 8 }}>
              تا تاریخ ثبت
            </label>
            <DatePicker
              value={filterData?.to_tm}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              onChange={(e) => {
                changeDataFilter({ to_tm: e });
              }}
            />
          </div>
          <div className="col-6 mt-2 px-1">
            <label className="form-label-custom" style={{ marginBottom: 8 }}>
              از تاریخ سفارش
            </label>
            <DatePicker
              value={filterData?.from_order_tm}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              onChange={(e) => {
                changeDataFilter({ from_order_tm: e });
              }}
            />
          </div>
          <div className="col-6 mt-2 px-1">
            <label className="form-label-custom" style={{ marginBottom: 8 }}>
              تا تاریخ سفارش
            </label>
            <DatePicker
              value={filterData?.to_order_tm}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              onChange={(e) => {
                changeDataFilter({ to_order_tm: e });
              }}
            />
          </div>
          <div className="d-flex justify-content-end mt-3 w-100">
            <CustomButton
              size="medium "
              className=" me-1"
              onClick={() => {
                changeDataFilter({
                  type: "",
                  product: { properties: [] },
                  customer: "",
                  paid_status: "",
                  production_status: "",
                  financial_status: "",
                  store_status: "",
                  order_status: "",
                  from_tm: "",
                  to_tm: "",
                  from_order_tm: "",
                  to_order_tm: "",
                });
                setFilterFlag(false);
                orderListFunc({}, 1);
              }}
              color="danger"
            >
              حذف فیلتر
            </CustomButton>
            <CustomButton
              size="medium "
              className=""
              onClick={() => {
                filterFunc(filterData);
              }}
              color="info"
            >
              فیلتر
            </CustomButton>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
